(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ll-cart-fans"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function inject() {
      var tpl = document.getElementById('ll-cart-fans-tpl');
      if (!tpl) return;
      document.querySelectorAll('.cart-drawer .cart-header-blocks').forEach(function (host) {
        if (host.querySelector('.ll-fans')) return;
        var drawer = host.closest('cart-drawer');
        var count = drawer ? drawer.querySelectorAll('[data-ref="cart-item"]').length : 1;
        if (!count) return;
        host.insertBefore(tpl.content.cloneNode(true), host.firstChild);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inject); else inject();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(inject, 50); }).observe(document.documentElement, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
